import { render, staticRenderFns } from "./PostponeForm.vue?vue&type=template&id=cf440dfc&scoped=true&"
import script from "./PostponeForm.vue?vue&type=script&lang=js&"
export * from "./PostponeForm.vue?vue&type=script&lang=js&"
import style0 from "./PostponeForm.vue?vue&type=style&index=0&id=cf440dfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf440dfc",
  null
  
)

export default component.exports